import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-verifica-utente',
  templateUrl: './verifica-utente.component.html',
  styleUrls: ['./verifica-utente.component.css']
})
export class VerificaUtenteComponent implements OnInit {
  titolo: string = '';
  frmInserimento!: FormGroup;
  objdettaglio: any

  constructor(public dialogRef: MatDialogRef<VerificaUtenteComponent>,
    private srvUtilita: UtilitaService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.titolo = 'Verifica Utente'
  }

  ngOnInit(): void {
    this.frmInserimento = this.fb.group({
      isVerificato:[null]
    })

    if (this.data.iValore > 0) {
      this.getDettaglio(this.data.iValore)
    }
  }

  getDettaglio(iValore: number) {
    this.srvUtilita.getObj('Utenti/GetUtentiDettaglio?idUtentiProfilo=' + iValore).subscribe((res: any) => {
      this.objdettaglio = res
      //console.log(res, 'res')
      this.frmInserimento.patchValue(this.objdettaglio)
      this.titolo = this.titolo + ": " + this.objdettaglio.Cognome + " " + this.objdettaglio.Nome
  })
  }

  btnSalva() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value

    if (objInserimento.isVerificato == true) {
      objInserimento.isVerificato = 1
    } else {
      objInserimento.isVerificato = 0
    }

    const obj =
    {
      idUtentiProfilo: this.data.iValore,
      isVerificato: objInserimento.isVerificato
    }
   
    this.srvUtilita.postObj('Utenti/PostUtentiVerificato', obj).subscribe((res: any) => {
      this.showMessage('Utente VERIFICATO', 'OK')
     // this.srvUtilita.postObj('Utenti/PostAttivazioneProfilo', obj).subscribe((res: any) => {
      this.dialogRef.close()
   /* }, (err: any) => {
      //  this.showMessage('Errore', 'OK')
      })*/
    }, (err: any) => {
      this.showMessage('Utente NON VERIFICATO', 'OK')
    })
  }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }
  btnAnnulla(): void {
    this.showMessage('Operazione annullata.', 'OK')
    this.dialogRef.close()
  }

}
